import React from 'react';
import { Box, Container, makeStyles } from '@material-ui/core';

interface HeroUnitProps {
    title: string | React.ReactNode;
    subTitle: string | React.ReactNode;
    smaller?: boolean;
    children?: React.ReactNode;
}

const css = makeStyles(theme => ({
    heroContent: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(16, 0),
    },
    heroContentSmaller: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(6, 0, 0, 0),
    },
}));

export const HeroUnit = ({
    title,
    subTitle,
    children,
    smaller = false,
}: HeroUnitProps): JSX.Element => {
    const classes = css();

    return (
        <div className={smaller ? classes.heroContentSmaller : classes.heroContent}>
            <Container maxWidth="md">
                <Box
                    mb={2}
                    fontWeight={'bold'}
                    fontSize={'45px'}
                    textAlign="center"
                    color="info.main"
                >
                    {title}
                </Box>
                <Box mb={4} fontSize={'22px'} fontWeight={300} textAlign={'center'}>
                    {subTitle}
                </Box>
                {children}
            </Container>
        </div>
    );
};

// <Box textAlign="center">
//     <SearchBar
//         value={localState.publicAppListingSearchTerm}
//         placeholder={'Find the right app for you'}
//         onSearch={value => {
//             client.writeData({
//                 data: { publicAppListingSearchTerm: value },
//             });
//         }}
//     />
// </Box>
